(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http', 'toastr', '$translate'];

    function JhiConfigurationService ($filter, $http, toastr, $translate) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function onError(error) {
            if(error.status === 403){
                toastr.error($translate.instant('error.access.external.forbidden'));
            } else {
                toastr.error(error.data);
            }
        }

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete, onError);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete, onError);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
